import React, { Fragment } from 'react'
import { RefiTransactionsCard } from './refiTransactionsCard'
import { RefiTransactionsRow } from './refiTransactionsRow'
import { displayDollars } from '../../helpers/displayFormatHelper'

const RefiTransactionsSelectedProducts = (props) => {
  const selectedProducts = props.selectedProducts ? props.selectedProducts : []

  return selectedProducts.map((product) => {
    const { selectedProductOption } = product
    const { selectedSurchargeCodes, surcharges } = selectedProductOption

    const filteredSurcharges = surcharges
      .filter(({ SurchargeCode }) =>
        selectedSurchargeCodes?.includes(SurchargeCode)
      )
      .map((surcharge, idx, arr) => (
        <Fragment key={surcharge?.SurchargeCode}>
          <RefiTransactionsRow
            field={surcharge?.Description}
            fieldsBold
            hasBottomBorder={arr.length - 1 > idx}
          >
            {displayDollars(surcharge?.Price)}
          </RefiTransactionsRow>
        </Fragment>
      ))

    return (
      <RefiTransactionsCard key={product.id} title="SELECTED PRODUCT">
        <RefiTransactionsRow field="Id" fieldsBold hasBottomBorder>
          {product.id}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="Description" fieldsBold hasBottomBorder>
          {product?.description}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="Deductible" fieldsBold hasBottomBorder>
          {selectedProductOption?.deductible}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="Monthly Price" fieldsBold hasBottomBorder>
          {displayDollars(selectedProductOption?.monthlyPayment)}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="Total Price" fieldsBold>
          {displayDollars(selectedProductOption?.totalPrice)}
        </RefiTransactionsRow>
        <div style={{ height: 10 }} />
        <RefiTransactionsCard key={product.id} title="Selected Product Option">
          <RefiTransactionsRow field="Id" fieldsBold hasBottomBorder>
            {selectedProductOption?.id}
          </RefiTransactionsRow>
          <RefiTransactionsRow
            field={selectedProductOption?.description}
            fieldsBold
            hasBottomBorder={filteredSurcharges.length > 0}
          />
          {filteredSurcharges}
        </RefiTransactionsCard>
      </RefiTransactionsCard>
    )
  })
}

export default RefiTransactionsSelectedProducts
